import { render, staticRenderFns } from "./ova.vue?vue&type=template&id=1dcc6194&scoped=true"
import script from "./ova.vue?vue&type=script&lang=ts"
export * from "./ova.vue?vue&type=script&lang=ts"
import style0 from "./ova.vue?vue&type=style&index=0&id=1dcc6194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc6194",
  null
  
)

export default component.exports